import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalDescription, ModalTitle } from "@air/primitive-modal";
import { tailwindMerge } from "@air/tailwind-variants";
import pluralize from "pluralize";
import { useCallback } from "react";
export const BulkDownloadAssetsModal = (param)=>{
    let { clipIds, onClose, onDownloadAsZip, onDownloadIndividually } = param;
    /**
   * This is an arbitrary number that we use to determine if we should show the option to download individually
   * or as a zip.
   *
   * @see https://air-labs-team.slack.com/archives/C04SUMD2ULF/p1740013219518209?thread_ts=1739988638.505229&cid=C04SUMD2ULF
   */ const canDownloadIndividually = clipIds.length < 50;
    const handleDownloadAsZip = useCallback(()=>{
        onDownloadAsZip();
        onClose();
    }, [
        onClose,
        onDownloadAsZip
    ]);
    const handleDownloadIndividually = useCallback(()=>{
        onDownloadIndividually();
        onClose();
    }, [
        onClose,
        onDownloadIndividually
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: true,
        "data-testid": "BULK_DOWNLOAD_ASSETS_MODAL",
        onDismiss: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ _jsxs(ModalTitle, {
                            children: [
                                "Download ",
                                pluralize("asset", clipIds.length, true),
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ModalDescription, {
                            children: canDownloadIndividually ? "You can download these ".concat(pluralize("asset", clipIds.length, true), " as individual files or a single zip. A zip offers some compression but may take a few minutes to generate.") : "Downloading more than ".concat(pluralize("asset", clipIds.length, true), " requires Air to prepare a zip file. This may take a few minutes. Your download will begin automatically once the zip is ready.")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("footer", {
                    className: tailwindMerge("flex gap-2", canDownloadIndividually ? "justify-end" : "justify-between"),
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            appearance: "ghost",
                            color: "grey",
                            onClick: onClose,
                            size: "large",
                            children: "Cancel"
                        }),
                        canDownloadIndividually ? /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    appearance: "outline",
                                    "data-testid": "BULK_DOWNLOAD_ASSETS_MODAL_ZIP_BUTTON",
                                    color: "grey",
                                    onClick: handleDownloadAsZip,
                                    size: "large",
                                    children: "Download as zip"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    appearance: "filled",
                                    "data-testid": "BULK_DOWNLOAD_ASSETS_MODAL_INDIVIDUAL_BUTTON",
                                    onClick: handleDownloadIndividually,
                                    size: "large",
                                    children: "Download individually"
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(Button, {
                            appearance: "filled",
                            "data-testid": "BULK_DOWNLOAD_ASSETS_MODAL_ZIP_BUTTON",
                            color: "blue",
                            onClick: handleDownloadAsZip,
                            size: "large",
                            children: "Download"
                        })
                    ]
                })
            ]
        })
    });
};
